import React, { useEffect, useState } from 'react'
import { Container } from 'react-bootstrap'

function GrievancePolicy() {


    const [pageTitle,setPageTitle] = useState('About Us');
                    const [pageContent,setPageContent] = useState('');
                useEffect(() => {
                        getData()
                    }, []);
                    const getData = async () => {
                        try {
                            const response = await fetch('https://api.kahaaniplus.com/api/v1/page/grievance-policy');
                            const data = await response.json();
                            setPageTitle(data.data.page_title);
                            setPageContent(data.data.page_content);
                            console.log(data);
                        } catch (error) {
                            console.error('Error fetching data:', error);
                        }
                    };



    return (
        <Container className='mt-5'>
            <h1 className='text-center'>{pageTitle}</h1>
            <p  className='my-para'  dangerouslySetInnerHTML={{ __html: pageContent }}>
               {/*  We at TIARA DIGITAL SERVICES PRIVATE LIMITED continuously strive to give our users the best possible service and experience. We aim to provide a hassle free and quick turnaround timeline to resolve the user queries/complaints.<br/><br/>
                <b>DETAILS OF OUR DESIGNATED GRIEVANCE OFFICER</b><br/>
                Grievance Officer: Pankaj Sharma<br/>
                Email Id: pankaj@globocom.info<br/>
                Contact Details: 9818771230<br/>
                Address: 1001, 10th Floor, First Avenue Building, Goregaon-Mulund Link Road, Malad(W), Mumbai 400064, Maharashtra, India.<br/>
                One can raise a legal query/complaint by contacting us on the above-mentioned contact numbers or by emailing us at contactus@tiaradigital.in<br/>
                Upon receipt of the complaint the same shall be acknowledged within a period of 24 hours.<br/>
                Our team will resolve the query/complaint within 15 days from the date of receipt of complaint to bring an unmatched viewing experience to our esteemed customers
            */}
            </p>
        </Container>
    )
}

export default GrievancePolicy